export default (theme) => ({
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 16,
    },
    actionsRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
    },
    body: {
        marginTop: 40,
    },
    centerContent: {
        height: '100%',
        width: '100%',
        maxWidth: 500,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 0,
        padding: 0,
        margin: 'auto',
        '&, & *': {
            boxSizing: 'border-box',
        },
    },
    illustration: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 180,
        height: 180,
        borderRadius: '50%',
        backgroundColor: theme.colors.primary.black,
        marginTop: 24,
        aspectRatio: '1/1',
    },
    illustrationNoBackdrop: {
        backgroundColor: 'transparent',
        borderRadius: 0,
        width: 210,
        aspectRatio: '210/180',
        marginTop: 0,
    },
});
